<template>
    <div>
        <b-row>
            <b-col>
                <p class="mb-1 ml-1 text-muted text-uppercase">
                    <small>
                        <i class="icon-speech"></i>
                        {{ $t('pdis.informations.moreInformations') }}
                    </small>
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-list-group>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <small class="text-muted title"> {{ $t('pdis.pdi') }}: </small>
                        <b-badge variant="light" class="text-muted" pill>
                            {{ data.title }}
                        </b-badge>
                    </b-list-group-item>

                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <small class="text-muted title">{{ $t('form.label.period') }}:</small>
                        <b-badge variant="light" class="text-muted" pill>
                            {{ data.due_date | formatDate }}
                        </b-badge>
                    </b-list-group-item>

                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <small class="text-muted title">{{ $t('pdis.form.budget') }}:</small>
                        <b-badge variant="light" class="text-muted" pill> ${{ formattedBudget }} </b-badge>
                    </b-list-group-item>

                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <small class="text-muted title">{{ $t('people.status') }}:</small>
                        <b-badge :variant="getStatusVariant" pill>
                            {{ getStatusTitle }}
                        </b-badge>
                    </b-list-group-item>

                    <b-list-group-item>
                        <small class="text-muted title mr-1">Tags: </small>
                        <b-badge
                            v-for="tags in data.tags"
                            :key="tags.id"
                            variant="primary"
                            class="text-white mr-1"
                            pill
                        >
                            {{ tags.title }}
                        </b-badge>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import i18n from '@/i18n'
import { getDateWithTime } from '@/lib/date'
import { formatNumber } from '@/lib/utils'

export default {
    name: 'Informations',
    props: ['data'],
    computed: {
        getStatusTitle() {
            return i18n.t(`pdis.checkins.form.labels.${this.data.status}`).toLowerCase()
        },
        getStatusVariant() {
            switch (this.status) {
                case 'finished':
                    return 'success'
                case 'in_progress':
                    return 'warning'
                default:
                    return 'danger'
            }
        },
        formattedBudget() {
            const value = this.numberFormatter(this.data.budget, 2)
            return value == false ? '-' : value
        },
    },
    methods: {
        numberFormatter(value) {
            return formatNumber(value, 2)
        },
    },
    filters: {
        formatDate(date) {
            return getDateWithTime(date, 'DD/MM/YYYY')
        },
    },
}
</script>
